(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sunlife-purchase-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sunlife-purchase-panel')) {
    customElements.define('sunlife-purchase-panel', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const quantity = this.querySelector('input[name="quantity"]');
        const minus = this.querySelector('[data-sl-minus]');
        const plus = this.querySelector('[data-sl-plus]');
        const sync = () => {
          if (!quantity) return;
          quantity.value = String(Math.min(99, Math.max(1, Math.floor(Number(quantity.value) || 1))));
          minus.disabled = Number(quantity.value) <= 1;
          plus.disabled = Number(quantity.value) >= 99;
        };
        const change = (difference) => {
          quantity.value = String(Number(quantity.value || 1) + difference);
          sync();
          quantity.dispatchEvent(new Event('change', { bubbles: true }));
        };
        minus?.addEventListener('click', () => change(-1), options);
        plus?.addEventListener('click', () => change(1), options);
        quantity?.addEventListener('change', sync, options);
        this.querySelector('form')?.addEventListener('submit', sync, options);
        sync();
        const volume = this.querySelector('details');
        this.querySelector('[data-sl-volume-link]')?.addEventListener('click', (event) => {
          event.preventDefault();
          volume.open = true;
          volume.querySelector('summary').focus({ preventScroll: true });
          volume.scrollIntoView({ block: 'nearest' });
        }, options);
        this.querySelector('[data-sl-return]')?.addEventListener('click', () => {
          (quantity || this.querySelector('.sl-purchase-pending a'))?.focus({ preventScroll: true });
        }, options);
        const sticky = this.querySelector('[data-sl-sticky]');
        const controls = this.querySelector('.sl-shop__controls, .sl-purchase-pending');
        if (sticky && controls) {
          const updateSticky = () => {
            this.frame = null;
            sticky.hidden = controls.getBoundingClientRect().bottom >= 80;
          };
          const scheduleSticky = () => {
            if (!this.frame) this.frame = requestAnimationFrame(updateSticky);
          };
          window.addEventListener('scroll', scheduleSticky, { ...options, passive: true });
          window.addEventListener('resize', scheduleSticky, options);
          if ('IntersectionObserver' in window) {
            this.observer = new IntersectionObserver(scheduleSticky);
            this.observer.observe(controls);
          }
          updateSticky();
        }
      }
      disconnectedCallback() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = null;
        this.observer?.disconnect();
        this.controller?.abort();
        this.controller = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
